<div class="title">О регбийной лиге “Трудовые резервы”</div>
<div class="text">
  <p>
  Стартует четвертый сезон. В лиге принимают участие 34 команды со всей России. В рамках регбийной лиги участвуют 6 дивизионов, 3 московских (центр-1, центр-2, женский).
  </p>
  <p>
  Каждая игра сопровождается профессиональными судьями из федерации регби России, максимально точной статистикой, трансляциями в режиме реального времени и работой комментаторов.
  </p>
  <p>
  Чемпионат включает в себя 31 игровую недель в формате регби-15, которые продлятся до 29 сентября. А женский дивизион в формате регби-7, который пройдёт в четыре тура. На протяжении всех матчей формируется статистика команд и отдельно каждого игрока. Платформа с уникальным механизмом подсчета статистики фиксирует попытки, их реализацию, проценты выигранных схваток, молов, раков и коридоров.
  </p>
  <p>
  Федеральная регбийная лига «Трудовые резервы» задействовала лучший регбийный стадион Москвы: «Фили»
  </p>
</div>

<div class="statistic">
  <div class="item">
    <div class="name">
      Количество
      <br />
      сыгранных игр
    </div>
    <div class="value">{{ statistic?.games_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество игроков
      <br />
      в лиге
    </div>
    <div class="value">{{ statistic?.players_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Набрано
      <br />
      очков
    </div>
    <div class="value">{{ statistic?.points_sum || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество
      <br />
      попыток
    </div>
    <div class="value">{{ statistic?.tries_sum || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Забито
      <br />
      голов
    </div>
    <div class="value">{{ statistic?.goals_sum || 0 }}</div>
  </div>
</div>

<div class="join">
  Присоединяйся к Регбийной Лиге "Трудовые резервы"
  <a href="javascript:;" class="btn" (click)="openJoinForm()">Присоединиться</a>
</div>
